
import BasePageView from "components/core/BasePageView/BasePageView";
import useDDPodFormV2Logic from "./useDDPodFormV2Logic";
import DDPodFormV2Desktop from "./DDPodFormV2Desktop";
import DDPodFormV2Mobile from "./DDPodFormV2Mobile";

const DDPodFormV2 = () => {
    const vm = useDDPodFormV2Logic();

    return (
        <BasePageView
            DesktopView={DDPodFormV2Desktop}
            MobileView={DDPodFormV2Mobile}
            viewProps={vm}
        />
    );
};

export default DDPodFormV2;
